import { createSlice } from '@reduxjs/toolkit';

const pageState = createSlice({
  name: 'pageState',
  initialState: null,
  reducers: {
    setCurrentPageState(state, action) {
      return action.payload;
    },
    clearPageState(state, action){
      return null;
    }
  }
});

export const { setCurrentPageState, clearPageState } = pageState.actions;
export default pageState.reducer;